<template>
  <v-content id="login">
    <v-container fluid fill-height>
      <v-row dense align="center" justify="center">
        <v-col cols="12" sm="8" md="4"
          :class="['fm', {error: config.status.animate}]"
        >
          <v-card class="elevation-12">
            <v-card-text>
              <v-img contain :src="logo" height="150" aspect-ratio="1"></v-img>
              <v-form ref="form" v-model="form.valid" lazy-validation="">
                <v-text-field
                  ref="userid"
                  name="login"
                  v-model="form.userid"
                  prepend-icon="fa-user"
                  label="ユーザー名"
                  type="text"
                  :rules="rules.userid"
                  @keyup.enter="login"
                />
                <v-text-field
                  name="password"
                  v-model="form.passwd"
                  prepend-icon="fa-lock"
                  label="パスワード"
                  type="password"
                  :rules="rules.passwd"
                  @keyup.enter="login"
                />
              </v-form>
              <p v-show="config.status.error" class="body-1 red--text text-xs-right">{{ printError }}</p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn depressed
                class="secondary white--text"
                :disabled="!isValid"
                :loading="isLoading"
                @click="login"
              >ログイン</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
export default {
  name: 'login',
  components: {
  },
  data () {
    return {
      logo: require('@/assets/logo_square.png'),
      config: {
        status: {
          error: '',
          animate: false,
          loading: false
        }
      },
      form: {
        valid: true,
        userid: '',
        passwd: ''
      },
      rules: {
        userid: [
          v => !!v || '必須項目です'
        ],
        passwd: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  mounted () {
    this.auth()
    this.$nextTick(() => {
      if (this.$refs.userid) {
        this.$refs.userid.focus()
      }
    })
  },
  methods: {
    auth: function () {
      this.$firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          this.$author.auth(user).then(author => {
            let qs = this.$route.query
            this.$set(this.config.status, 'error', '')
            this.$set(this.config.status, 'loading', false)
            this.$store.commit('author/update', author)
            this.$router.push('redirect' in qs ? qs.redirect : '/')
          }).catch(err => {
            console.log(err)
          })
        }
      })
    },
    login: function () {
      if (this.$refs.form.validate()) {
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().setPersistence(this.$firebase.auth.Auth.Persistence.LOCAL).then(() => {
          this.$firebase.auth().signInWithEmailAndPassword(this.form.userid, this.form.passwd).then(() => {
          }).catch((error) => {
            console.log(error)
            this.$set(this.config.status, 'loading', false)
            this.$set(this.config.status, 'error', 'fail')
            this.$set(this.config.status, 'animate', true)
            setTimeout(() => {
              this.$set(this.config.status, 'animate', false)
            }, 500)
          })
        }).catch((error) => {
          console.log(error)
          this.$set(this.config.status, 'loading', false)
          this.$set(this.config.status, 'error', 'fail')
        })
      } else {
        this.$set(this.config.status, 'error', 'require')
      }
    }
  },
  computed: {
    isValid () {
      return this.form.valid
    },
    isLoading () {
      return this.config.status.loading
    },
    printError () {
      return this.$error.login[this.config.status.error] ? this.$error.login[this.config.status.error] : ''
    }
  }
}
</script>

<style lang="scss">
#login {
  .fm {
    &.error {
      animation: shaking .16s infinite;
    }
  }
}
</style>
